import type { BlogPost } from './types'

export const WIR_SIND_LIVE: BlogPost = {
  slug: 'wir-sind-live',
  lang: 'de',
  topicId: 'wir-sind-live',
  title: 'Roofora ist live – ohne Anruf-Flut',
  metaDescription:
    'Roofora ist live: der Marktplatz, auf dem Handwerksbetriebe um Ihren Solaranlagen-Auftrag ' +
    'konkurrieren - ohne Anruf-Flut, ohne Kaltakquise.',
  keywords: [
    'Roofora live',
    'Solaranlage Angebote vergleichen ohne Anrufe',
    'Photovoltaik Marktplatz Start',
    'Solaranlage Angebote ohne Kaltakquise',
    'PV Angebote einholen ohne Anruf-Terror',
  ],
  publishedAt: '2026-07-11',
  excerpt:
    'Der Hintergrund: Ich hab selbst mal ein Angebot für eine Solaranlage angefragt und wurde ' +
    'danach von gefühlt jeder Firma zugespamt. Das hat mich so genervt, dass ich mir gedacht ' +
    'hab: das geht besser. Also hab ich es selbst gebaut - und jetzt ist Roofora live.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Der Hintergrund: Ich hab selbst mal ein Angebot für eine Solaranlage angefragt und ' +
        'wurde danach von gefühlt jeder Firma zugespamt - tausende Anrufe und E-Mails, ' +
        'überteuerte Angebote, Kaltakquise ohne Ende. Das hat mich so genervt, dass ich mir ' +
        'gedacht hab: das geht besser. Also hab ich es selbst gebaut.',
    },
    {
      type: 'paragraph',
      text:
        'Das Ergebnis ist Roofora - und ab heute ist die Plattform live. Kein Konzept mehr, ' +
        'keine Beta-Ankündigung "demnächst" - Sie können ab sofort eine Anfrage stellen und ' +
        'echte Angebote von Handwerksbetrieben erhalten, ohne danach Ihr Telefon ausschalten zu ' +
        'müssen.',
    },
    {
      type: 'heading',
      text: 'Was bei klassischen Vergleichsportalen schiefläuft',
    },
    {
      type: 'paragraph',
      text:
        'Das Muster kennen viele: Eine Anfrage stellen, die eigene Telefonnummer und E-Mail-Adresse ' +
        'eintragen - und schon wird derselbe Lead an mehrere Firmen gleichzeitig verkauft. Die ' +
        'Folge ist eine Anruf-Flut, bei der man irgendwann nicht mehr weiß, welcher Anrufer ' +
        'eigentlich zu welchem Angebot gehört. Genau dieses Grundproblem wollten wir bei Roofora ' +
        'nicht nur abmildern, sondern strukturell verhindern.',
    },
    {
      type: 'heading',
      text: 'Wie Roofora stattdessen funktioniert',
    },
    {
      type: 'list',
      items: [
        'Anfrage stellen: Dachbilder, Zählerschrank-Foto, Dachausrichtung und Jahresverbrauch angeben - die passende Anlagengröße wird automatisch berechnet',
        'Anonymisierte Veröffentlichung: Handwerksbetriebe sehen Ihre Anfrage, aber keine Kontaktdaten',
        'Handwerker geben unabhängig voneinander unverbindliche Festpreis-Angebote ab - ganz ohne Ihr Zutun',
        'Sie vergleichen die Angebote sortiert nach Preis, ganz in Ruhe',
        'Kontakt entsteht ausschließlich, wenn Sie einem einzelnen Handwerksbetrieb aktiv zustimmen - keine Sammelfreigabe an alle Anbieter',
        'Ein Konto brauchen Sie nur mit Username und Passwort - weder E-Mail noch Telefonnummer sind zur Registrierung nötig',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Dazu gibt es einen kostenlosen PV-Rechner ganz ohne Anmeldung, mit dem Sie in wenigen ' +
        'Minuten eine erste Einschätzung zu Anlagengröße und Ertrag Ihres Dachs bekommen - inklusive ' +
        'PDF-Export der Analyse.',
    },
    {
      type: 'heading',
      text: 'Für Handwerksbetriebe',
    },
    {
      type: 'paragraph',
      text:
        'Solarteure und Elektrofachbetriebe sehen anonymisierte Anfragen aus ihrer Region - inklusive ' +
        'Dachdaten, Verbrauch und dem aktuell niedrigsten Angebot, aber ohne Kontaktdaten. Ein Angebot ' +
        'abzugeben ist kostenlos und unverbindlich. Möchte ein Betrieb darüber hinaus Kontakt zum ' +
        'Kunden aufnehmen, sendet er eine ebenfalls kostenlose Kontaktanfrage und wartet auf die ' +
        'individuelle Freigabe durch genau diesen Kunden.',
    },
    {
      type: 'heading',
      text: 'Ehrlich gesagt: aktuell ein Hobbyprojekt, komplett kostenlos',
    },
    {
      type: 'paragraph',
      text:
        'Roofora ist aktuell ein privates Hobbyprojekt im Beta-Betrieb - für Kunden und ' +
        'Handwerksbetriebe gleichermaßen vollständig kostenlos. Kein verstecktes Zahlungsmodell, ' +
        'keine Kreditkarte, keine Abo-Falle. Sollte sich das perspektivisch ändern, werden wir das ' +
        'transparent ankündigen - bis dahin gilt: ausprobieren kostet nichts.',
    },
    {
      type: 'paragraph',
      text:
        'Wenn Sie eine Solaranlage planen und keine Lust auf Anruf-Terror haben, probieren Sie ' +
        'Roofora aus - die Anfrage ist in wenigen Minuten gestellt, und Sie entscheiden jederzeit ' +
        'selbst, wer Sie erreichen darf.',
    },
  ],
  relatedLinks: [
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Was kostet eine Solaranlage?', href: '/solaranlage-kosten' },
  ],
}
